import { Component, OnInit, HostListener, ChangeDetectorRef } from '@angular/core';
import { SideNavServiceService } from '../../../core/services/side-nav/side-nav-service.service';
import { filter, Subscription } from 'rxjs';
import { AuthenticationService } from '../../../core/services/authentication/authentication.service';
import { RedirectService } from '../../../core/services/redirect/redirect.service';
import { AuthorizationService } from '../../../core/services/authorization/authorization.service';
import { ConfigService } from '../../../core/services/config.service';
import { NavBarService } from '../../../core/services/nav-bar/nav-bar.service';
import { LoaderService } from '../../../core/services/loader/loader.service';
import { Subject } from 'rxjs';
import { User } from '../../models/user';
import { OrderPipe } from '../../../shared/components/pipes/order/order.pipe';
import { ClientService } from 'src/app/core/services/client/client.service';
import { ClientsList } from '../../models/app.config';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { NavigationEnd, Router } from '@angular/router';
import { Constants } from '../../constants';
import { SplunkService } from 'src/app/core/services/splunk/splunk.service';
import { MatDialog } from '@angular/material/dialog';
import { WaiversService } from 'src/app/waiver-management/services/waivers/waivers.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {

  currentUser: User;
  currentUserSubscription: Subscription;
  logOutOldURL = 'Default.aspx?action=logout';
  moduleClass = '';

  showPageTitleBarSubscription: Subscription;
  pageTitleBarText = '';
  showPageTitleBar = false;
  defaultpageTitleBarText = 'Welcome to Partner Center';
  menuUrls = this.configService.menuUrls;
  selectedClient: any;
  selectedClientSubscription: Subscription;
  isEmailNotificationsEnabled = true;
  isApproveCoverageEnabled = true;

  homeModule = {
    blockName: 'HOME',
    title: 'Click here to go to Home page.',
    url: '#',
    name: 'home',
    description: undefined
  };

  modules = this.orderPipe.transform(this.configService.modules, ['order'], false);
  masterModules = JSON.parse(JSON.stringify(this.configService.modules));

  userActivity;
  userInactive: Subject<any> = new Subject();
  disableEvents = true;
  moduleWiseClients: ClientsList = new ClientsList();
  moduleClientsSubscription: Subscription;
  clientListModules: string[] = ['AllClients', Constants.WaiverManagement, Constants.InsuranceManagement, Constants.Referrals, Constants.LedgerBilling, /*Constants.ClaimsManagement,*/ Constants.PaymentManagement];
  handleList: boolean;
  clients: any;
  moduleChangedSubject: Subscription;
  selectedModule: any;
  selectionFromTop: boolean;
  supportEmail: string;
  dialogBox: any;
  applyMargin: boolean;
  spinnerSubscribe: Subscription;
  loading: boolean;
  policyLoader: boolean;
  spinnerPolicySubscribe: any;
  getPermissionsSubscription: Subscription | null = null;

  constructor(
    private sideNavService: SideNavServiceService,
    private authenticationService: AuthenticationService,
    private redirectService: RedirectService,
    private authorizationService: AuthorizationService,
    private configService: ConfigService,
    private navBarService: NavBarService,
    private loaderService: LoaderService,
    private orderPipe: OrderPipe,
    public dialog: MatDialog,
    private router: Router,
    private clientService: ClientService,
    private splunkService: SplunkService,
    private waiversService: WaiversService,
    private cdr: ChangeDetectorRef
  ) {
    this.supportEmail = this.configService.supportEmail;
    this.handleList = false;
    this.selectedClientSubscription = this.clientService.selectedClient.subscribe(client => {
      if (client) {
        if (!this.selectedClient) {
          this.selectedClient = client;
        } else {
          if (client.Number !== this.selectedClient.Number) {
            this.selectedClient = client;
          }
        }
      }
    });

    this.showPageTitleBarSubscription = this.navBarService.getTitleBarValue().subscribe(value => {
      if (value) {
        this.showPageTitleBar = true;
        this.pageTitleBarText = value;
      } else {
        this.showPageTitleBar = false;
        this.pageTitleBarText = '';
      }

    });
    this.configService.disableEvent.subscribe(con => {
      this.disableEvents = con;
    });
    this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
      this.currentUser = user;
      if (user) {
        this.updateSubFeatureTiles();
        this.cdr.detectChanges();
      }
    });
    this.moduleClientsSubscription = this.clientService.moduleWiseClients.subscribe(moduleClients => {
      this.moduleWiseClients = moduleClients;
      // Re-evaluate canAccess() on the nav items when the client list changes
      // (e.g. after school-setup saves and refreshes permissions in-place).
      this.cdr.detectChanges();
    });
    this.moduleChangedSubject = this.clientService.moduleChanged.subscribe(module => {
      if (module) {
        this.showSelectClient(module);
      }
    });
    this.setTimeout();
    this.userInactive.subscribe(() => {
      if (this.authenticationService.isMyAccountTokenExpired()) {
        this.logOutFromOldSite();
      } else {
        this.setTimeout();
      }
    });
    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        var moduleName = event.urlAfterRedirects.split("/")[1].replace("/", "").replace("-", " ").split(" ");
        for (let i = 0; i < moduleName.length; i++) {
          moduleName[i] = moduleName[i][0].toUpperCase() + moduleName[i].substring(1);
        }
        var moduleSelected = moduleName.join(" ");
        moduleSelected = moduleSelected != "Dashboard" ? moduleSelected : "Home";
        this.applyMargin = moduleSelected !== 'Home';
        var BlockSelected = "";
        if (event.urlAfterRedirects.split("/").length == 4 || event.urlAfterRedirects.split("/").length == 3) {
          var blockName = event.urlAfterRedirects.split("/")[event.urlAfterRedirects.split("/").length - 1].replace("/", "").replace(/-/gi, " ").split(" ");
          for (let i = 0; i < blockName.length; i++) {
            blockName[i] = blockName[i][0].toUpperCase() + blockName[i].substring(1);
          }
          BlockSelected = blockName.join(" ");
        }
        this.onRouterNavgation(moduleSelected, BlockSelected, event.urlAfterRedirects);
        // if (moduleSelected === 'Home' && this.authenticationService.isLoggedIn()) {
        //   this.getClients();
        // }
      });
    this.spinnerSubscribe = this.loaderService.hideSpinner.subscribe(value => {
      if (!this.policyLoader)
        this.loading = value;
    });
    this.spinnerPolicySubscribe = this.loaderService.hidePolicySpinner.subscribe(value => {
      this.policyLoader = value;
      this.loading = value;
    });
  }

  ngOnInit() {
    setTimeout(() => {
      if (this.authenticationService.isLoggedIn() && !this.moduleWiseClients && Object.keys(this.currentUser.profile.Permissions).length > 0) {
        this.getClients();
      }
    }, 100);
  }
   isInsuranceModule() {
    return (location.pathname.indexOf('insurance-management') > -1 || location.pathname.indexOf('claims-management') > -1);
  }

  isSchoolSetupModule() {
    return location.pathname.includes('school-setup');
  }  
  canAccess(module) {
    let flag = this.authorizationService.canAccess(module);
    module.isDisabled = !flag;
    if (this.isWaiver(module.blockName)) {
      flag = true;
    }
    return flag;
  }

  isWaiver(blockName: string) {
    if (blockName === Constants.WaiverManagement) {
      return true;
    } else {
      return false;
    }
  }

  onModuleClick(module) {
    if (module.transform) {
      this.loaderService.handleSpinner(true);
    }
  }
  OnNavigationSubNav(moduleName, blockName, blockUrl) {
    this.selectionFromTop = true;
    this.handleList = false;
    this.clientService.handleSchoolSelectPage(true);
    if (moduleName.permission.indexOf(Constants.WaiverManagement) > -1 && !this.selectedClient) {

      if (this.moduleWiseClients.WaiverManagement.length === 1) {
        this.clientService.setSelectedClient(this.moduleWiseClients.WaiverManagement[0]);
        this.router.navigateByUrl(blockUrl);
      }
      else if (this.moduleWiseClients.WaiverManagement.length > 1) {
        this.selectedModule = module;
        this.selectedModule.url = blockUrl;
        this.router.navigateByUrl(blockUrl.split('/')[0]);
        this.clients = this.moduleWiseClients.WaiverManagement;
        this.handleList = true;
        this.clientService.handleSchoolSelectPage(false);


      }
      this.onClickSubNavgation(blockName, moduleName, blockUrl);
      return false;
    }
    else {
      this.router.navigate([blockUrl]);
    }
    this.splunkService.log('info', {
      request: moduleName,
      response: { result: blockName }
    }, this.authenticationService.getUserProfile?.UserId, this.selectedClient?.Id);
  }
  onRouterNavgation(module, blockName, blockurl) {
    var elements = document.getElementsByClassName('subnav-content');
    if (module == "Home") {
      document.getElementById('navHome').classList.remove("subnavbtn");
      document.getElementById('navHome').classList.add("subnavHomeColor");
    }
    else {
      document.getElementById('navHome').classList.add("subnavbtn");
      document.getElementById('navHome').classList.remove("subnavHomeColor");
    }
    if ((module == "Waiver Management" && this.selectedClient) || (module != "Waiver Management")) {
      for (var i = 0; i < elements.length; i++) {
        var subNavId = elements[i].id;
        var subAccess = elements[i].getAttribute("access");
        var navId = elements[i].id.split('subnav');
        if (subAccess == "true" && subNavId.includes(module)) {
          document.getElementById('nav' + navId[1]).classList.add("navColor");
          document.getElementById(subNavId).classList.add("subnavBlock");
          this.onClickSubNavgation(blockName, module, blockurl);
        }
        else if (subAccess == "true") {
          document.getElementById('nav' + navId[1]).classList.remove("navColor");
          document.getElementById(subNavId).classList.remove("subnavBlock");
          this.onClickSubNavgation(blockName, module, blockurl);
        }
      }
      var subNavHeight = document.getElementById('subnav' + module)?.offsetHeight;
      if (subNavHeight)
        document.getElementById("navbar").style.marginBottom = subNavHeight.toString() + "px";
      // localStorage.setItem('selectedModule',JSON.stringify(module));
    }

  }
  onClickNavgation(module, navigate = true) {
    this.selectionFromTop = true;
    this.handleList = false;
    this.clientService.handleSchoolSelectPage(true);

    let _url = this.isWaiver(module.moduleName) && module.isDisabled ? '#' : module.url;
    if (!module.transform && navigate) {
      if (module.permission.indexOf(Constants.WaiverManagement) > -1 && !this.selectedClient) {

        if (this.moduleWiseClients.WaiverManagement.length === 1) {
          this.clientService.setSelectedClient(this.moduleWiseClients.WaiverManagement[0]);
          this.router.navigateByUrl(_url);
        }
        else if (this.moduleWiseClients.WaiverManagement.length > 1) {
          this.selectedModule = module;
          this.selectedModule.url = _url;
          this.clients = this.moduleWiseClients.WaiverManagement;
          this.handleList = true;
          this.clientService.handleSchoolSelectPage(false);
        }
      }
      else if (module.permission.indexOf(Constants.WaiverManagement) > -1 && this.selectedClient) {
        let validClient = this.currentUser.profile.Permissions.WaiverManagement?.AllowedClientIds?.indexOf(this.selectedClient.Id.toString()) > -1;

        // Check for client access if no permissions check for single or multiple open school select if accessable redirect to module
        if (validClient) {
          this.router.navigateByUrl(_url);
        }
        else {
          if (this.moduleWiseClients.WaiverManagement.length === 1) {
            this.openDialog('FeatureNotEnabled');
            this.dialogBox.afterClosed().subscribe(data => {
              if (data) {
                this.clientService.setSelectedClient(this.moduleWiseClients.WaiverManagement[0]);
                this.redirectService.goToModule(module);
              }
              this.dialogBox.afterClosed().unsubscribe();
              this.dialogBox = undefined;
            });
          }
          else if (this.moduleWiseClients.WaiverManagement.length > 1) {
            this.clients = this.moduleWiseClients.WaiverManagement;
            this.handleList = true;
            this.selectedModule = module;
            this.selectedModule.url = _url;
            this.clientService.handleSchoolSelectPage(false);
          }
        }
      }
      else {
        this.router.navigateByUrl(_url);
      }
    }
    else if (module.transform && navigate) {
      this.clients = this.moduleWiseClients[module.permission];
      if (this.selectedClient) {
        let validClient = this.currentUser.profile.Permissions[module.permission]?.AllowedClientIds?.indexOf(this.selectedClient.Id.toString()) > -1;
        if (validClient) {
          this.redirectService.goToModule(module);
        }
        else {
          if (this.clients.length === 1) {
            this.openDialog('FeatureNotEnabled');
            this.dialogBox.afterClosed().subscribe(data => {
              if (data) {
                this.clientService.setSelectedClient(this.clients[0]);
                this.redirectService.goToModule(module);
              }
              this.dialogBox.afterClosed().unsubscribe();
              this.dialogBox = undefined;
            });

          }
          else if (this.clients.length > 1) {
            this.handleList = true;
            this.selectedModule = module;
            this.selectedModule.url = _url;
            this.clientService.handleSchoolSelectPage(false);
          }
        }
      }
      else if (this.clients.length === 1) {
        this.clientService.setSelectedClient(this.clients[0]);
        this.redirectService.goToModule(module);
        this.clientService.handleSchoolSelectPage(false);
      }
      else if (this.clients.length > 0) {
        this.handleList = true;
        this.clientService.handleSchoolSelectPage(false);
        this.selectedModule = module;
        this.selectedModule.url = _url;
      }
    }
    else {
      this.clientService.handleSchoolSelectPage(true);
      this.applyMargin = false;
    }
    this.splunkService.log('info', {
      request: module,
      response: { result: module.blockName }
    }, this.authenticationService.getUserProfile?.UserId, this.selectedClient?.Id);
  }
  onClickSubNavgation(blockName, moduleName, blockurl) {
    var elements = document.getElementsByClassName('link' + moduleName);
    var blockSelected = "";
    if (blockurl.split("/").length == 4) {
      blockSelected = blockurl.split("/")[2].replace("/", "").replace(/-/gi, " ");
    }
    for (var i = 0; i < elements.length; i++) {
      var subNavId = elements[i].id;

      if (blockName != "" && subNavId.toUpperCase().includes(blockName.toUpperCase())) {
        document.getElementById(subNavId).classList.add("subnavColor");
      }
      else if (blockSelected != "" && subNavId.toLocaleLowerCase().includes(blockSelected.toLocaleLowerCase()))
        document.getElementById(subNavId).classList.add("subnavColor");
      else {
        document.getElementById(subNavId).classList.remove("subnavColor");
      }
    }


  }

  onModuleChange(): void {
    this.loaderService.handleSpinner(true);
  }

  getFullUrl(module) {
    if (!module) {
      return;
    }

    if (typeof module === 'string') {
      return this.redirectService.getFullUrl(module, true);
    }

    if (module.transform) {
      return this.redirectService.getFullUrl(module.url, true);
    } else {
      return module.url;
    }
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.currentUserSubscription.unsubscribe();
    this.showPageTitleBarSubscription.unsubscribe();
    this.userInactive.unsubscribe();
    this.moduleClientsSubscription.unsubscribe();
    this.moduleChangedSubject.unsubscribe();
    this.spinnerSubscribe.unsubscribe();
    this.spinnerPolicySubscribe?.unsubscribe();
    this.getPermissionsSubscription?.unsubscribe();
  }

  toggleSideNav() {
    this.sideNavService.toggle();
  }

  isAuthenticated(): boolean {
    return (this.currentUser && this.currentUser.profile.UserName !== '');
  }


  isInternalUser() {
    return this.currentUser.profile.UserType === 'INTERNAL';
  }

  hasSchoolSetupAccess(): boolean {
    if (!this.currentUser || !this.currentUser.profile.Permissions) { return false; }
    return Object.keys(this.currentUser.profile.Permissions).indexOf(Constants.SchoolSetup) !== -1;
  }

  onSchoolSetupMenuClick(): void {
    // Reset any open school-select state so the outlet/selector is re-evaluated,
    // even when the browser URL does not change (same-route re-click).
    this.selectionFromTop = false;
    this.handleList = false;
    this.clientService.handleSchoolSelectPage(true);

    const schoolSetupClients = this.moduleWiseClients?.SchoolSetup ?? [];
    const hasValidSelectedClient = !!this.selectedClient &&
      schoolSetupClients.some((client: any) => client?.Id === this.selectedClient?.Id);

    const schoolSetupModule = {
      module: Constants.SchoolSetup,
      blockName: 'Setup Features',
      transform: false,
      url: `/${Constants.SchoolSetupPath}/setup-features`
    };

    if (hasValidSelectedClient) {
      this.router.navigateByUrl(schoolSetupModule.url);
      return;
    }

    if (schoolSetupClients.length === 1) {
      this.clientService.setSelectedClient(schoolSetupClients[0]);
      this.router.navigateByUrl(schoolSetupModule.url);
      return;
    }

    // Multiple clients and none selected: open the shared selector for School Setup.
    this.showSelectClient(schoolSetupModule);
  }

  onLogOut() {
    this.navBarService.clearTitleBarValue();
    this.logOutFromOldSite();

  }

  // logout from old site
  logOutFromOldSite() {
    window.location.href = this.redirectService.getFullUrl(this.logOutOldURL, false);
  }

  setTimeout() {
    this.userActivity = setTimeout(() => this.userInactive.next(undefined), 60 * 1000 * this.configService.user_Session_Timeout);
  }

  @HostListener('document:keyup', ['$event'])
  @HostListener('document:click', ['$event'])
  @HostListener('document:wheel', ['$event'])
  refreshUserState() {
    clearTimeout(this.userActivity);
    this.setTimeout();
  }

  HasAcesstoSubModule(blockName) {
    if (blockName == "View Archived Students") {
      return false;
    }
    if (this.selectedClient && ((blockName == "Schedule Email Notifications") || (blockName == "Approve Coverage"))) {
      if (blockName == "Approve Coverage") {
        let IsCoverageElectionEnabled = this.selectedClient?.EnrollmentEnabled && !this.selectedClient?.EarlyEnrollment;
        this.isApproveCoverageEnabled = this.selectedClient?.AutoConversionEnabled || (IsCoverageElectionEnabled);
        return this.isApproveCoverageEnabled;
      }
      else if (blockName == "Schedule Email Notifications") {
        this.isEmailNotificationsEnabled = (this.selectedClient?.EmailNotificationEnabled && this.currentUser?.profile?.Permissions[Constants.WaiverManagement]?.ScheduleEmailNotifications !== undefined) ? true : false;
        return this.isEmailNotificationsEnabled;
      }
    }
    else if (blockName == Constants.ManageSHCBilling || blockName == Constants.ManageReferrals) {
      return this.masterModules[1].blocks.find(f => f.blockName == blockName);
    }
    else {
      return true;
    }
  }
  updateSubFeatureTiles(): void {
    this.masterModules.forEach(element => {
      const module = this.currentUser?.profile?.Permissions[element.permission];
      if (module) {
        element.blocks = element.blocks.filter(e => {
          return Object.keys(module).map(e => e = e.toLowerCase()).includes(e.blockName.replaceAll(' ', '').toLowerCase());
        });
      }
    });
  }
  openDialog(type: string): void {
    let alertBoxData = {};
    if (type === 'FeatureNotEnabled') {
      alertBoxData = {
        title: 'Notice!',
        message: `The feature is not enabled for the selected school or user profile. \n You'll be redirected to a school which has this feature enabled.`
      };
    } else if (type === 'AccessRestricted') {
      alertBoxData = {
        title: 'Notice',
        message: 'Access Restricted.'
      };
    } else if (type === 'FeatureRestricted') {
      alertBoxData = {
        title: 'Notice',
        message: `The feature has not been enabled for your school. Please contact <a href="mailto:${this.supportEmail}">Partner Center Support</a> for assistance.`
      };
    }

    this.dialogBox = this.dialog.open(AlertBoxComponent, {
      width: '400px',
      data: alertBoxData,
      disableClose: false,
      autoFocus: false,
      panelClass: 'search-dialog-container'
    });

  }
getClients() {
    this.authorizationService.getPermissions(this.currentUser.profile.UserName, this.currentUser.profile.Roles)
      .subscribe(permissions => {
        if (this.currentUser.profile.Roles.indexOf('rWaiver Management Internal Verification Admin') > -1) {
          this.waiversService.filterThirdPartyVerificationEnabledClients(permissions.AllowedClients)
	}
        else
          this.clientService.createClientList(permissions.AllowedClients);
      });
  }
  async selectClient(client) {
    this.handleList = false;
    if (!this.selectionFromTop) {
      this.selectionFromTop = false;
      this.handleClientWisePermission(client);
    }
    else {
      this.redirectTo(client);
    }
  }

  redirectTo(client) {
    this.clientService.setSelectedClient(client);
    const hasAccess = client.hasAccess;
    // check for module access
    //if (hasAccess) {
    this.goToModule(this.selectedModule);
    // } else {
    //   this.closeClientSelect(true);
    // }
    this.clientService.moduleChangedevent(null);
  }

  goToModule(module) {
    this.redirectService.goToModule(module);
  }

  closeClientSelect($event) {
    this.selectionFromTop = false;
    this.handleList = false;
    this.clientService.handleSchoolSelectPage(true);
  }

  showSelectClient(module) {
    const permission = module.module;
    let moduleName = permission.startsWith(Constants.WaiverManagement) ? Constants.WaiverManagement :
      permission.startsWith(Constants.ClaimsManagement) ? Constants.ClaimsManagement : permission.startsWith(Constants.PaymentManagement) ? Constants.PaymentManagement : permission.startsWith(Constants.InsuranceManagement) ? Constants.InsuranceManagement :
        permission.startsWith(Constants.SchoolSetup) ? Constants.SchoolSetup : '';
    let clientList: any;
    if (moduleName === '') {
      clientList = this.moduleWiseClients.AllClients;
      this.showClient(module, clientList);
    }
    else if (moduleName != '' && this.moduleWiseClients[moduleName]) {
      if (module.module.indexOf(Constants.LedgerBilling) !== -1)
        clientList = this.moduleWiseClients.ManageSHCBilling;
      else if (module.module.indexOf(Constants.Referrals) !== -1)
        clientList = this.moduleWiseClients.ManageReferrals;
      else
        clientList = this.moduleWiseClients[moduleName];
      this.showClient(module, clientList);
    }
  }

  showClient(module, clientList) {
    // if (module.isAutoConversionEnabled) {
    //   this.clients = clientList.filter(client => client.AutoConversionEnabled);
    // } else if (module.isEmailNotificationEnabled && !this.isWaiverInternalAdminRole()) {
    //   this.clients = clientList.filter(client => client.EmailNotificationEnabled);
    // } else if (module.isEnrollmentRequired && module.isEarlyEnrollment) {
    //   this.clients = clientList.filter(client => client.EnrollmentEnabled && client.EarlyEnrollment);
    // } else if (module.isEnrollmentRequired && !module.isEarlyEnrollment) {
    //   this.clients = clientList.filter(client => client.EnrollmentEnabled && !client.EarlyEnrollment);
    // } else {
    this.clients = clientList;
    // }
    //this.clients = this.createClientList(this.clients);
    this.selectedModule = module;
    this.clients.forEach(client => {
      client.hasAccess = true;
    });
    if (!this.selectedClient && this.clients.length === 1) {
      this.selectClient(this.clients[0]);
    }
    else {
      this.handleList = true;
      this.clientService.handleClientList(false);
      this.clientService.handleSchoolSelectPage(false);
    }
  }
  isWaiverInternalAdminRole() {
    return this.currentUser.profile.Roles.indexOf('rWaiver Management Internal Admin') > -1;
  }

  handleClientWisePermission(client): void {
    let hasAccess = true;
    if (this.selectedModule.blockName === Constants.ScheduleEmailNotificationsBlockName) {
      hasAccess = ((this.currentUser?.profile?.Permissions?.WaiverManagement?.AllowedClientIds?.indexOf(client.Id.toString()) !== -1 || Object.keys(this.currentUser?.profile?.Permissions).indexOf('WaiverManagement') !== -1) && client?.EmailNotificationEnabled);
      this.selectedModule.url = hasAccess ? this.selectedModule.url : '/waiver-management';
    }
    else if (this.selectedModule.blockName === Constants.LedgerBillingBlockName) {
      if (!this.moduleWiseClients.ManageSHCBilling.find(f => f.Id === client.Id)) {
        hasAccess = false;
        this.selectedModule.url = '/dashboard';
        this.selectedModule.transform = false;
      }
    }
    else if (this.selectedModule.blockName === Constants.Referrals) {
      if (!this.moduleWiseClients.ManageReferrals.find(f => f.Id === client.Id)) {
        hasAccess = false;
        this.selectedModule.url = '/dashboard';
        this.selectedModule.transform = false;
      }
    }
    this.redirectTo(client);
    if (!hasAccess)
      this.openDialog('FeatureRestricted');
  }
}
